import { openShare } from '@/lib/share'
import { Directory, File, Paths } from 'expo-file-system'

function base64ToUint8Array(base64: string) {
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}

export async function saveImageFromBase64(base64: string, filename: string, extension = 'png') {
  try {
    const file = new File(Paths.cache, `${filename}.${extension}`)
    if (!file.exists) {
      file.create()
    }
    file.write(base64ToUint8Array(base64.replace(/^data:image\/\w+;base64,/, '')))

    await openShare({
      url: file.uri,
      type: `image/${extension}`,
      failOnCancel: false,
    })
  } catch (error) {
    console.error(error)
  }
}

export async function saveFileFromRemoteUrl(url: string) {
  const destination = new Directory(Paths.cache, 'files')
  if (!destination.exists) {
    destination.create()
  }

  const output = await File.downloadFileAsync(url, destination)
  await openShare({
    url: output.uri,
    failOnCancel: false,
  })
}
